export default __webpack_public_path__ + "static/media/dpap.05b8537a.png";